export default "__VITE_ASSET__BKbFxvsx__"